export const formatLocalTime = (utcTimestamp: number, type = "DD/MM/YYYY") => {
  const date = new Date(utcTimestamp * 1000);
  let hours = date.getHours();
  hours = hours === 24 ? 0 : hours;
  const time = `${hours.toString().padStart(2, "0")}:${date
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  if (type === "DD/MM/YYYY h:mm") {
    return `${day}/${month}/${year} ${time}`;
  } else if (type === "h:mm DD/MM") {
    return `${time} ${day}/${month}`;
  } else if (type === "DD/MM h:mm") {
    return `${day}/${month} ${time}`;
  } else if (type === "DD/MM") {
    return `${day}/${month}`;
  } else if (type === "MM/YYYY") {
    return `${month}/${year}`;
  } else if (type === "YYYY") {
    return `${year}`;
  }

  return `${day}/${month}/${year}`;
};

export const calculateAge = (timestamp: number): number => {
  if (!timestamp) return 0;

  const birthDate = new Date(timestamp * 1000);
  const today = new Date();
  
  const age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  // Nếu chưa tới tháng sinh nhật hoặc 
  // đang đúng tháng nhưng chưa tới ngày sinh nhật thì trừ 1
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    return age - 1;
  }
  
  return age;
};

export const formatNumberToShort = (num: number): string => {
  if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
  if (num >= 1_000_000)     return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (num >= 1_000)         return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
  return num.toString();
}
